import React from "react";

export default function Footer() {
  return (
    <footer style={{
      background: "#ffb300",
      color: "#fff",
      textAlign: "center",
      padding: "12px 0",
      marginTop: "auto"
    }}>
      &copy; {new Date().getFullYear()} School Finance Accounting System
    </footer>
  );
}